import {createAsyncThunk} from '@reduxjs/toolkit'

import {SHOPPING_HOME} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

/** 쇼핑 홈으로 이동 */
const navigateToShoppingHome = createAsyncThunk<NavigationResult, NavigationTypeSelectableParam | void, ThunkApi>(
    'navigateTo/shoppingHome',
    async (args) => {
        const {forceLocationChange = false} = args ?? {}

        if (forceLocationChange) {
            changeBrowserLocation({
                // 반응형으로 구현되어 PC/MO 분리 없음
                url: SHOPPING_HOME,
                type: 'PUSH',
            })
            // page 이동은 그 자체로 추가동작 없이 resolve 된다
            return Promise.resolve()
        }

        openNewTab({url: SHOPPING_HOME})
    },
)

export default navigateToShoppingHome
